
import { defineComponent } from 'vue'
import { EpbLoading } from '../components/shared/epb-loading'

export default defineComponent({
  name: 'LoadingMask',
  components: {
    EpbLoading,
  },
})
